import moment from 'moment';

const defaultState = {
	daterange: {
		startDate: moment().startOf('month'),
		endDate: moment(),
	},
	dataUsage: [],
	typeFilter: 'fltered',
    zonesExitEntryReport: null,
}

const driver = (state = defaultState, action) => {
	switch (action.type) {
        case 'SET_REPORTS_DATAUSAGE': {
            return { ...state, dataUsage: action.payload }
        }
        case 'SET_REPORTS_DATERANGE': {
            return { ...state, daterange: action.payload }
        }
        case 'SET_REPORTS_FILTER': {
            return { ...state, typeFilter: action.payload }
        }
        case 'SET_ZONES_REPORT': {
            return { ...state, zonesExitEntryReport: action.payload }
        }
        case 'RESET_ZONES_REPORT': {
            return { ...state, zonesExitEntryReport: null }
        }
        default:
            return state
	}
}

export default driver
